var render = function render(_c,_vm){return _c('div',{staticClass:"v-chevron",style:({ transform: `rotate(${_vm.props.value ? -180 : 0}deg)` })},[_c('font-awesome-icon',{style:({ color: _vm.props.color }),attrs:{"size":"sm","icon":"chevron-down"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }